(function(angular){
	'use strict';

	angular
		.module('apiModule', [
			'coreModule'
		]);

})(window.angular);